import Vue from 'vue';
import Toast from 'vue-toastification';

const options = {
  position: 'bottom-right',
  hideProgressBar: true,
};

Vue.use(Toast, options);
